import { Offering } from 'types/Portfolio/StructuredOffering'

export function isInCapitalFormationPeriod(portfolio: Offering) {
  return portfolio.status === 'Fundraising'
}
